import { useColorScheme, useLocalStorage } from '@mantine/hooks';
import { useEffect } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const useBookitupTheme = () => {
  const [colorScheme, setColorScheme] = useLocalStorage({
    key: 'mantine-color-scheme',
    defaultValue: 'light',
    getInitialValueInEffect: true,
  });
  const systemTheme = useColorScheme(); // Device color scheme
  const getFinalValue = (val: string) => (val !== 'auto' ? val : systemTheme);

  useEffect(() => {
    // Load dark styles : form_builder & calendar_view & timeline_view
    if (getFinalValue(colorScheme) === 'dark' && !document.body.classList.contains('dark')) {
      document.body.classList.add('dark');
    }
    if (getFinalValue(colorScheme) === 'light' && document.body.classList.contains('dark')) {
      document.body.classList.remove('dark');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colorScheme, systemTheme]);

  return [getFinalValue(colorScheme), setColorScheme];
};
